export default "__VITE_ASSET__BDc$hwit__"